import React, { useState } from "react";
import {
  Carousel,
  CarouselControl,
  CarouselIndicators,
  CarouselItem,
  Col,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { handleCheckboxChange } from "./Constants/ModifyAddOfferFunctions";
import { useEffect } from "react";

const AddOfferForPolicyCorousel = ({
  setSelectedOnes,
  open,
  toggle,
  loading,
  filteredResults,
  setExpandedServices,
  selectedOffers,
  setSelectedOffers,
  selectAllOffers,
  onChangeSelectAll,
  handleEnter,
}) => {
  const [openViewMoreModalKey, setOpenViewMoreModalKey] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isMediumToLargeScreen, setIsMediumToLargeScreen] = useState(
    window.innerWidth >= 768 && window.innerWidth < 1400
  );
  const [animating, setAnimating] = useState(false);
  const [activeIndices, setActiveIndices] = useState({});

  const next = (key, chunkCount) => {
    setActiveIndices((prev) => ({
      ...prev,
      [key]: ((prev[key] ?? 0) + 1) % chunkCount,
    }));
  };

  const previous = (key, chunkCount) => {
    setActiveIndices((prev) => ({
      ...prev,
      [key]: ((prev[key] ?? 0) - 1 + chunkCount) % chunkCount,
    }));
  };

  const goToIndex = (key, index) => {
    setActiveIndices((prev) => ({
      ...prev,
      [key]: index,
    }));
  };

  const openViewMoreModal = (index, offerIndex) => {
    setOpenViewMoreModalKey(`${index}-${offerIndex}`);
  };

  const closeViewMoreModal = () => {
    setOpenViewMoreModalKey(null);
  };

  const OfferCard = ({
    offer,
    isModal,
    openViewMoreModal,
    index,
    offerIndex,
  }) => {
    return (
      <div
        className={`${
          !isModal
            ? "border border-1 border-gray rounded-1 p-3 h-100 d-flex flex-column justify-content-between"
            : ""
        }`}
      >
        {!isModal ? (
          <div className="d-flex justify-content-between align-items-center py-2 flex-wrap">
            <h3
              className="fs-5 text-black fw-bold mb-0 truncate-single-line"
              title={offer.offerName}
              style={{ maxWidth: "90%" }}
            >
              {offer.offerName}
            </h3>
            <Input
              type="checkbox"
              className=" border-black fs-5"
              checked={selectedOffers.some(
                (o) => o.offerCode === offer.offerCode
              )}
              onChange={() =>
                handleCheckboxChange(
                  offer,
                  selectedOffers,
                  setSelectedOffers,
                  setSelectedOnes
                )
              }
              style={{
                borderWidth: "2px",
                borderColor: "#000",
                borderRadius: "0",
              }}
            />
          </div>
        ) : null}
        <div className="py-3">
          <span className="fs-5  text-wrap  w-100 text-break">
            <span
              className="rv-offer-code px-2 py-1 d-inline-block rounded-2 fw-bold truncate-single-line"
              title={offer.offerCode}
              style={{ maxWidth: "100%" }}
            >
              {offer.offerCode.toUpperCase()}
            </span>
          </span>
        </div>
        <div className="py-3">
          <div className="d-flex align-items-center">
            <span
              className="rv-primary-background-color p-1 rounded-circle d-flex align-items-center justify-content-center"
              style={{ width: "32px", height: "32px" }}
            >
              <i class="ri-calendar-2-line rv-text-primary-color"></i>
            </span>
            <div className="px-2">
              <h4 className="fs-14 mb-0 rv-text-label-color">Validity</h4>
              <h4 class="mb-0 fs-14 fw-semibold text-black">
                {offer.termValidity}
              </h4>
            </div>
          </div>
        </div>
        <div className="py-3">
          <div className="d-flex align-items-center">
            <span
              className="rv-grants-icon-bg p-1 rounded-circle d-flex align-items-center justify-content-center"
              style={{ width: "32px", height: "32px" }}
            >
              <i class="ri-gift-line rv-grants-icon-color"></i>
            </span>
            <div className="px-2">
              <h4 className="fs-14 mb-0 rv-text-label-color">Grants</h4>
              {!isModal &&
                (offer?.GrantCard?.length ? (
                  <h4 class="mb-0">
                    {" "}
                    <span className="fw-semibold fs-14 text-black">
                      {offer?.GrantCard[0].grantAmount}{" "}
                      {offer?.GrantCard[0].uom}{" "}
                    </span>
                    {offer?.GrantCard?.length - 1 > 0 ? (
                      <span className="rv-text-label-color fs-12 ms-2">
                        {" "}
                        + {offer?.GrantCard?.length - 1} more
                      </span>
                    ) : (
                      ""
                    )}
                  </h4>
                ) : (
                  <h4 class="mb-0">
                    <span className="fw-semibold fs-14 text-black">
                      No grants available
                    </span>
                  </h4>
                ))}
            </div>
          </div>
          {isModal && (
            <div className="ms-32">
              {offer?.GrantCard?.length ? (
                offer?.GrantCard?.map((grant, index) => (
                  <h4
                    key={index}
                    className="text-black rv-whisper-gray-bg p-1 d-flex justify-content-between align-items-center"
                  >
                    <span className="fs-14 fw-semibold">
                      {grant?.grantAmount} {grant?.uom}
                    </span>{" "}
                    <span className="fs-12">{grant?.oneTimeorRecurring}</span>
                  </h4>
                ))
              ) : (
                <h4 class="mb-0">
                  <span className="fs-14 text-black rv-whisper-gray-bg p-1 d-flex justify-content-between align-items-center">
                    No grants available
                  </span>
                </h4>
              )}
            </div>
          )}
        </div>
        <div className="py-3">
          <div className="d-flex align-items-center">
            <span
              className="rv-charge-icon-bg p-1 rounded-circle d-flex align-items-center justify-content-center"
              style={{ width: "32px", height: "32px" }}
            >
              <i class="ri-layout-top-line rv-charge-icon-color"></i>
            </span>
            <div className="px-2">
              <h4 className="fs-14 mb-0 rv-text-label-color">Charges</h4>

              {!isModal &&
                (offer?.ChargeCard?.length ? (
                  <h4 class="mb-0">
                    {" "}
                    <span className="fw-semibold fs-14 text-black">
                      {offer?.ChargeCard[0].currencySymbol}{" "}
                      {offer?.ChargeCard[0].chargeAmount}{" "}
                    </span>
                    {offer?.ChargeCard?.length - 1 > 0 ? (
                      <span className="rv-text-label-color fs-12 ms-2">
                        {" "}
                        + {offer?.ChargeCard?.length - 1} more
                      </span>
                    ) : (
                      ""
                    )}
                  </h4>
                ) : (
                  <h4 class="mb-0">
                    <span className="fw-semibold fs-14 text-black">
                      No charges available
                    </span>
                  </h4>
                ))}
            </div>
          </div>
          {isModal && (
            <div className="ms-32">
              {offer?.ChargeCard?.length ? (
                offer?.ChargeCard?.map((charge, index) => (
                  <h4
                    key={index}
                    className="text-black rv-whisper-gray-bg p-1 d-flex justify-content-between align-items-center"
                  >
                    <span className="fs-14 fw-semibold">
                      {charge?.currencySymbol} {charge?.chargeAmount}
                    </span>
                    <span className="fs-12">{charge?.oneTimeorRecurring}</span>
                  </h4>
                ))
              ) : (
                <h4 class="mb-0">
                  <span className="fs-14 text-black rv-whisper-gray-bg p-1 d-flex justify-content-between align-items-center">
                    No charges available
                  </span>
                </h4>
              )}
            </div>
          )}
        </div>
        <div className="min-height-21">
          {(!isModal ? offer?.categories?.slice(0, 4) : offer?.categories)
            ?.length > 0 && (
            <div className="d-flex flex-wrap gap-2 py-2">
              {(!isModal
                ? offer?.categories?.slice(0, 4)
                : offer?.categories
              )?.map((category, index) => (
                <span
                  key={index}
                  className="offer-category fs-14 px-2 rounded-2"
                >
                  {category}
                </span>
              ))}
            </div>
          )}

          {!isModal &&
            (offer?.categories?.length > 4 ||
              offer?.GrantCard?.length > 1 ||
              offer?.ChargeCard?.length > 1) && (
              <div className="d-flex justify-content-end">
                <span
                  className="text-blue cursor-pointer"
                  onClick={() => openViewMoreModal(index, offerIndex)}
                >
                  <i>View more</i>
                </span>
              </div>
            )}
        </div>
      </div>
    );
  };

  const offerSlides = (offers, serviceIndex) => {
    const numberOfItems = isMobile ? 1 : isMediumToLargeScreen ? 3 : 4;
    const offerChunks = [];
    for (let i = 0; i < offers.length; i += numberOfItems) {
      offerChunks.push(offers.slice(i, i + numberOfItems));
    }

    const slides = offerChunks.map((offerChunk, index) => (
      <CarouselItem
        key={`chunk-${index}`}
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
      >
        <div className="d-flex justify-content-center w-100">
          <Row className="px-2 w-95">
            {offerChunk.map((offer, offerIndex) => {
              const adjustedOfferIndex = index * numberOfItems + offerIndex;
              return (
                <Col
                  key={adjustedOfferIndex}
                  lg={4}
                  xxl={3}
                  sm={12}
                  className="mb-4"
                >
                  <OfferCard
                    offer={offer}
                    index={serviceIndex}
                    offerIndex={adjustedOfferIndex}
                    openViewMoreModal={openViewMoreModal}
                    offerCode={offer?.offerCode}
                  />
                  <Modal
                    isOpen={
                      openViewMoreModalKey ===
                      `${serviceIndex}-${adjustedOfferIndex}`
                    }
                    fade={false}
                    toggle={closeViewMoreModal}
                    centered={true}
                  >
                    <ModalHeader toggle={closeViewMoreModal}>
                      {offer?.offerName}
                    </ModalHeader>
                    <ModalBody>
                      <OfferCard
                        offer={offer}
                        index={serviceIndex}
                        offerIndex={adjustedOfferIndex}
                        openViewMoreModal={openViewMoreModal}
                        closeViewMoreModal={closeViewMoreModal}
                        isModal={true}
                      />
                    </ModalBody>
                  </Modal>
                </Col>
              );
            })}
          </Row>
        </div>
      </CarouselItem>
    ));

    return { slides, chunkCount: offerChunks.length };
  };

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === "Enter" && selectedOffers?.length > 0) {
        e.preventDefault();
        handleEnter();
      }
    };

    document.addEventListener("keydown", handleKeyPress);

    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [handleEnter]);

  return (
    <div className="offers">
      <div>
        {loading ? (
          <p></p>
        ) : (
          <div>
            {filteredResults?.map(([serviceName, offers], index) => {
              const { slides, chunkCount } = offerSlides(offers, index);
              const indicators = [];
              for (let i = 0; i < chunkCount; i++) {
                indicators.push({ key: "ind-" + i });
              }
              const currentIndex = activeIndices[serviceName] || 0;
              return (
                serviceName && (
                  <div key={index} className="py-3">
                    <div className="d-flex justify-content-center w-100">
                      <Row className="px-2 w-95">
                        <Col lg={10}>
                          <h2 className="fs-5 text-black fw-bold mb-0">
                            {serviceName}
                          </h2>
                        </Col>
                        <Col lg={2}>
                          {index === 0 && (
                            <div className="d-flex justify-content-end me-3">
                              <span>Select All</span>
                              <Input
                                type="checkbox"
                                className="fs-5 ms-3"
                                checked={selectAllOffers}
                                onChange={onChangeSelectAll}
                                style={{
                                  borderWidth: "2px",
                                  borderColor: "#000",
                                  borderRadius: "0",
                                }}
                              />{" "}
                            </div>
                          )}
                        </Col>
                      </Row>
                    </div>

                    <Carousel
                      activeIndex={currentIndex}
                      next={() => next(serviceName, chunkCount)}
                      previous={() => previous(serviceName, chunkCount)}
                      className="my-3"
                      interval={false}
                    >
                      <CarouselIndicators
                        items={indicators}
                        activeIndex={currentIndex}
                        onClickHandler={(newIdx) =>
                          goToIndex(serviceName, newIdx)
                        }
                      />

                      {slides}

                      <CarouselControl
                        direction="prev"
                        directionText="Previous"
                        onClickHandler={() => previous(serviceName, chunkCount)}
                        className={currentIndex === 0 ? "d-none" : ""}
                      />
                      <CarouselControl
                        direction="next"
                        directionText="Next"
                        onClickHandler={() => next(serviceName, chunkCount)}
                        className={
                          currentIndex == chunkCount - 1 ? "d-none" : ""
                        }
                      />
                    </Carousel>
                  </div>
                )
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default AddOfferForPolicyCorousel;
